module.exports = __webpack_public_path__ + "img/30ne.e7e39149.svg";